var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-import") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.998,16.0004 L2.002,16.0004 C0.898,16.0004 0,15.1024 0,13.9984 L0,11.0004 C0,10.4474 0.448,10.0004 1,10.0004 C1.552,10.0004 2,10.4474 2,11.0004 L2,13.9984 L13.998,14.0004 L14,11.0004 C14,10.4474 14.448,10.0004 15,10.0004 C15.552,10.0004 16,10.4474 16,11.0004 L16,13.9984 C16,15.1024 15.102,16.0004 13.998,16.0004 Z M11.5996,6.1996 C12.0416,6.5306 12.1316,7.1576 11.7996,7.5986 L8.7996,11.5986 C8.6116,11.8506 8.3146,12.0006 7.9996,12.0006 C7.6856,12.0006 7.3886,11.8506 7.2006,11.5986 L4.2006,7.5986 C3.8686,7.1576 3.9576,6.5306 4.4006,6.1996 C4.8406,5.8676 5.4686,5.9576 5.7996,6.3996 L7.0036,8.0056 L7.0036,1.0006 C7.0036,0.4466 7.4516,0.0006 8.0036,0.0006 C8.5566,0.0006 9.0036,0.4466 9.0036,1.0006 L9.0036,7.9946 L10.2006,6.3996 C10.5316,5.9586 11.1596,5.8696 11.5996,6.1996 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "features-import"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007FAD",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Miscellaneous/import",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesImport);
export default __webpack_public_path__ + "static/media/features-import.e842c679307ab946cf10abd96990e5bb.svg";
export { ForwardRef as ReactComponent };